import React from "react"

const NoAccessPage = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>You do not have access to this page</h1>
      <p>Please contact your administrator or return to the homepage.</p>
    </div>
  )
}

export default NoAccessPage
